import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { CommunicationProvider } from "../../../../shared/model";
import { useCommunicationService } from "../../../lib/hooks";
export var CommunicationService = function CommunicationService(_ref) {
  var children = _ref.children;
  var value = useCommunicationService();
  return /*#__PURE__*/React.createElement(CommunicationProvider, _extends({}, value, {
    "data-t-id": "context-CommunicationService"
  }), children);
};